import type { Tenant } from "@/types";
import { useTenant } from "@/user/services/tenant";

export function useCheckIfModuleDisabled(module: Tenant["modules"][number]) {
  const tenant = useTenant();

  return tenant.modules.includes(module);
}
